/**
 * Coups de pouce — attendu 623 (placer une fraction sur la droite graduée).
 *
 * Routage par generator_key. Exemples HORS pools : les septièmes
 * (b = 7 absent des 3 formats de placement : QCM/relier b ≤ 6,
 * interactif {2,3,4,5,6,8,10}).
 */

// Lire/placer une position, animé 4 temps (storyboard validé sur 621
// avant sa refonte « reports » — le geste lecture est chez 623) :
// unité surlignée → la part 1/7 → comptage 1..9 → le point 9/7.
const SVG_PLACER = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 155" width="290" height="150" role="img" data-etapes="4"
     aria-label="Demi-droite graduée de 0 à 2 : de 0 à 1 il y a 7 parts égales, des septièmes ; chaque graduation vaut un septième ; on compte 9 graduations depuis 0 ; le point est à 9 septièmes, soit une unité puis 2 graduations">
  <style>
    .anim { opacity: 1; }
    [data-caption] { opacity: 0; }
    [data-caption="4"] { opacity: 1; }
    @media (prefers-reduced-motion: no-preference) {
      .d1 { opacity: 0; animation: cp623pla 8s linear infinite 0s; }
      .c1 { opacity: 0; animation: cp623plac 8s linear infinite 0s; }
      .d2 { opacity: 0; animation: cp623pla 8s linear infinite 2s; }
      .c2 { opacity: 0; animation: cp623plac 8s linear infinite 2s; }
      .d3 { opacity: 0; animation: cp623pla 8s linear infinite 4s; }
      .c3 { opacity: 0; animation: cp623plac 8s linear infinite 4s; }
      .d4 { opacity: 0; animation: cp623pla 8s linear infinite 6s; }
      .c4 { opacity: 0; animation: cp623placf 8s linear infinite 6s; }
    }
    @keyframes cp623pla { 0%, 2% { opacity: 0; } 6%, 95% { opacity: 1; } 98%, 100% { opacity: 0; } }
    @keyframes cp623plac { 0%, 2% { opacity: 0; } 5%, 22% { opacity: 1; } 26%, 100% { opacity: 0; } }
    @keyframes cp623placf { 0%, 2% { opacity: 0; } 5%, 95% { opacity: 1; } 98%, 100% { opacity: 0; } }
  </style>
  <line x1="14" y1="70" x2="290" y2="70" stroke="#475569" stroke-width="1.5"/>
  <polygon points="296,70 288,66 288,74" fill="#475569"/>
  <line x1="20.0" y1="62.0" x2="20.0" y2="78.0" stroke="#475569" stroke-width="1.5"/>
  <line x1="38.6" y1="65.0" x2="38.6" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="57.1" y1="65.0" x2="57.1" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="75.7" y1="65.0" x2="75.7" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="94.3" y1="65.0" x2="94.3" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="112.9" y1="65.0" x2="112.9" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="131.4" y1="65.0" x2="131.4" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="150.0" y1="62.0" x2="150.0" y2="78.0" stroke="#475569" stroke-width="1.5"/>
  <line x1="168.6" y1="65.0" x2="168.6" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="187.1" y1="65.0" x2="187.1" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="205.7" y1="65.0" x2="205.7" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="224.3" y1="65.0" x2="224.3" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="242.9" y1="65.0" x2="242.9" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="261.4" y1="65.0" x2="261.4" y2="75.0" stroke="#475569" stroke-width="1"/>
  <line x1="280.0" y1="62.0" x2="280.0" y2="78.0" stroke="#475569" stroke-width="1.5"/>
  <text x="20.0" y="97" text-anchor="middle" font-size="11" fill="#475569">0</text>
  <text x="150.0" y="97" text-anchor="middle" font-size="11" fill="#475569">1</text>
  <text x="280.0" y="97" text-anchor="middle" font-size="11" fill="#475569">2</text>
  <g class="anim d1" data-etape="1">
    <rect x="20.0" y="58" width="130.0" height="24" fill="#fed7aa" fill-opacity="0.5"/>
  </g>
  <g class="anim d2" data-etape="2">
    <text x="38.6" y="40.0" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#b45309">1</text><line x1="32.1" y1="43.5" x2="45.1" y2="43.5" stroke="#b45309" stroke-width="1.1"/><text x="38.6" y="52.5" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#b45309">7</text>
    <line x1="38.6" y1="56" x2="38.6" y2="60" stroke="#b45309" stroke-width="1"/>
  </g>
  <g class="anim d3" data-etape="3">
    <circle cx="38.6" cy="70" r="2.6" fill="#f97316"/>
    <text x="38.6" y="112" text-anchor="middle" font-size="8.5" font-weight="bold" fill="#f97316">1</text>
    <circle cx="57.1" cy="70" r="2.6" fill="#f97316"/>
    <text x="57.1" y="112" text-anchor="middle" font-size="8.5" font-weight="bold" fill="#f97316">2</text>
    <circle cx="75.7" cy="70" r="2.6" fill="#f97316"/>
    <text x="75.7" y="112" text-anchor="middle" font-size="8.5" font-weight="bold" fill="#f97316">3</text>
    <circle cx="94.3" cy="70" r="2.6" fill="#f97316"/>
    <text x="94.3" y="112" text-anchor="middle" font-size="8.5" font-weight="bold" fill="#f97316">4</text>
    <circle cx="112.9" cy="70" r="2.6" fill="#f97316"/>
    <text x="112.9" y="112" text-anchor="middle" font-size="8.5" font-weight="bold" fill="#f97316">5</text>
    <circle cx="131.4" cy="70" r="2.6" fill="#f97316"/>
    <text x="131.4" y="112" text-anchor="middle" font-size="8.5" font-weight="bold" fill="#f97316">6</text>
    <circle cx="150.0" cy="70" r="2.6" fill="#f97316"/>
    <text x="150.0" y="112" text-anchor="middle" font-size="8.5" font-weight="bold" fill="#f97316">7</text>
    <circle cx="168.6" cy="70" r="2.6" fill="#f97316"/>
    <text x="168.6" y="112" text-anchor="middle" font-size="8.5" font-weight="bold" fill="#f97316">8</text>
    <circle cx="187.1" cy="70" r="2.6" fill="#f97316"/>
    <text x="187.1" y="112" text-anchor="middle" font-size="8.5" font-weight="bold" fill="#f97316">9</text>
  </g>
  <g class="anim d4" data-etape="4">
    <circle cx="187.1" cy="70" r="4.5" fill="none" stroke="#f97316" stroke-width="2.5"/>
    <text x="187.1" y="38.0" text-anchor="middle" font-size="10.5" font-weight="bold" fill="#f97316">9</text><line x1="180.6" y1="41.5" x2="193.6" y2="41.5" stroke="#f97316" stroke-width="1.1"/><text x="187.1" y="50.5" text-anchor="middle" font-size="10.5" font-weight="bold" fill="#f97316">7</text>
  </g>
  <g class="anim c1" data-caption="1">
    <text x="150" y="140" text-anchor="middle" font-size="11.5" fill="#334155">de 0 à 1, il y a <tspan font-weight="bold" fill="#b45309">7 parts</tspan> : des <tspan font-weight="bold" fill="#b45309">septièmes</tspan></text>
  </g>
  <g class="anim c2" data-caption="2">
    <text x="150" y="140" text-anchor="end" font-size="11.5" fill="#334155">chaque graduation vaut</text>
    <text x="164.0" y="132.0" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#b45309">1</text><line x1="157.5" y1="135.5" x2="170.5" y2="135.5" stroke="#b45309" stroke-width="1.1"/><text x="164.0" y="144.5" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#b45309">7</text>
  </g>
  <g class="anim c3" data-caption="3">
    <text x="150" y="140" text-anchor="middle" font-size="11.5" fill="#334155">compte <tspan font-weight="bold" fill="#f97316">9 graduations</tspan> depuis 0</text>
  </g>
  <g class="anim c4" data-caption="4">
    <text x="98" y="140" text-anchor="end" font-size="11.5" fill="#334155">le point est à</text>
    <text x="112.0" y="132.0" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#f97316">9</text><line x1="105.5" y1="135.5" x2="118.5" y2="135.5" stroke="#f97316" stroke-width="1.1"/><text x="112.0" y="144.5" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#f97316">7</text>
    <text x="124" y="140" font-size="11.5" fill="#334155">: une unité, puis 2 ✓</text>
  </g>
</svg>`.trim();

const FICHE_PLACER = {
    pages: [
        {
            titre: 'Placer une fraction sur la demi-droite',
            lignes: [
                'Le **dénominateur** te dit en combien de **parts égales** une unité est coupée.',
                'Compte les graduations depuis **0** : c\'est le **numérateur**.',
            ],
            svg: SVG_PLACER,
        },
    ],
};

// Encadrer une fraction : des paquets de 7 CUMULATIFS jusqu’à 30
// (7, 14, 21, 28 → + 2 → 30), compter les paquets pleins → entre 4
// et 5. Une seule page (retour user). Exemple hors pool : 30/7
// (a = 30 > 4b = 28 partout, b = 7 absent du V/F).
const SVG_PAQUETS = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 160" width="290" height="155" role="img" data-etapes="4"
     aria-label="On fait des paquets de 7 jusqu’à atteindre 30 : un paquet fait 7, puis 14, 21, 28. Avec 2 de plus on atteint 30 : impossible de faire un cinquième paquet plein. On compte 4 paquets pleins : 30 septièmes se situe entre 4 et 5, deux entiers consécutifs">
  <style>
    .anim { opacity: 1; }
    [data-caption] { opacity: 0; }
    [data-caption="4"] { opacity: 1; }
    @media (prefers-reduced-motion: no-preference) {
      .d1 { opacity: 0; animation: cp623paq 8s linear infinite 0s; }
      .c1 { opacity: 0; animation: cp623paqc 8s linear infinite 0s; }
      .d2 { opacity: 0; animation: cp623paq 8s linear infinite 2s; }
      .c2 { opacity: 0; animation: cp623paqc 8s linear infinite 2s; }
      .d3 { opacity: 0; animation: cp623paq 8s linear infinite 4s; }
      .c3 { opacity: 0; animation: cp623paqc 8s linear infinite 4s; }
      .d4 { opacity: 0; animation: cp623paq 8s linear infinite 6s; }
      .c4 { opacity: 0; animation: cp623paqcf 8s linear infinite 6s; }
    }
    @keyframes cp623paq { 0%, 2% { opacity: 0; } 6%, 95% { opacity: 1; } 98%, 100% { opacity: 0; } }
    @keyframes cp623paqc { 0%, 2% { opacity: 0; } 5%, 22% { opacity: 1; } 26%, 100% { opacity: 0; } }
    @keyframes cp623paqcf { 0%, 2% { opacity: 0; } 5%, 95% { opacity: 1; } 98%, 100% { opacity: 0; } }
  </style>
  <g class="anim d1" data-etape="1">
    <circle cx="34.0" cy="20.0" r="4.0" fill="#334155"/>
    <circle cx="49.0" cy="20.0" r="4.0" fill="#334155"/>
    <circle cx="64.0" cy="20.0" r="4.0" fill="#334155"/>
    <circle cx="79.0" cy="20.0" r="4.0" fill="#334155"/>
    <circle cx="94.0" cy="20.0" r="4.0" fill="#334155"/>
    <circle cx="109.0" cy="20.0" r="4.0" fill="#334155"/>
    <circle cx="124.0" cy="20.0" r="4.0" fill="#334155"/>
    <rect x="25.0" y="11.0" width="108.0" height="18" rx="9" fill="none" stroke="#b45309" stroke-width="1.8"/>
    <text x="140.0" y="24.0" font-size="11" font-weight="bold" fill="#b45309">7</text>
  </g>
  <g class="anim d2" data-etape="2">
    <circle cx="34.0" cy="42.0" r="4.0" fill="#334155"/>
    <circle cx="49.0" cy="42.0" r="4.0" fill="#334155"/>
    <circle cx="64.0" cy="42.0" r="4.0" fill="#334155"/>
    <circle cx="79.0" cy="42.0" r="4.0" fill="#334155"/>
    <circle cx="94.0" cy="42.0" r="4.0" fill="#334155"/>
    <circle cx="109.0" cy="42.0" r="4.0" fill="#334155"/>
    <circle cx="124.0" cy="42.0" r="4.0" fill="#334155"/>
    <rect x="25.0" y="33.0" width="108.0" height="18" rx="9" fill="none" stroke="#b45309" stroke-width="1.8"/>
    <text x="140.0" y="46.0" font-size="11" font-weight="bold" fill="#b45309">14</text>
    <circle cx="34.0" cy="64.0" r="4.0" fill="#334155"/>
    <circle cx="49.0" cy="64.0" r="4.0" fill="#334155"/>
    <circle cx="64.0" cy="64.0" r="4.0" fill="#334155"/>
    <circle cx="79.0" cy="64.0" r="4.0" fill="#334155"/>
    <circle cx="94.0" cy="64.0" r="4.0" fill="#334155"/>
    <circle cx="109.0" cy="64.0" r="4.0" fill="#334155"/>
    <circle cx="124.0" cy="64.0" r="4.0" fill="#334155"/>
    <rect x="25.0" y="55.0" width="108.0" height="18" rx="9" fill="none" stroke="#b45309" stroke-width="1.8"/>
    <text x="140.0" y="68.0" font-size="11" font-weight="bold" fill="#b45309">21</text>
    <circle cx="34.0" cy="86.0" r="4.0" fill="#334155"/>
    <circle cx="49.0" cy="86.0" r="4.0" fill="#334155"/>
    <circle cx="64.0" cy="86.0" r="4.0" fill="#334155"/>
    <circle cx="79.0" cy="86.0" r="4.0" fill="#334155"/>
    <circle cx="94.0" cy="86.0" r="4.0" fill="#334155"/>
    <circle cx="109.0" cy="86.0" r="4.0" fill="#334155"/>
    <circle cx="124.0" cy="86.0" r="4.0" fill="#334155"/>
    <rect x="25.0" y="77.0" width="108.0" height="18" rx="9" fill="none" stroke="#b45309" stroke-width="1.8"/>
    <text x="140.0" y="90.0" font-size="11" font-weight="bold" fill="#b45309">28</text>
  </g>
  <g class="anim d3" data-etape="3">
    <circle cx="34.0" cy="108.0" r="5.0" fill="#f97316"/>
    <circle cx="49.0" cy="108.0" r="5.0" fill="#f97316"/>
    <text x="70.0" y="112.0" font-size="11" font-weight="bold" fill="#f97316">30 !</text>
  </g>
  <g class="anim d4" data-etape="4">
    <text x="14" y="24.0" text-anchor="middle" font-size="11" font-weight="bold" fill="#f97316">1</text>
    <text x="14" y="46.0" text-anchor="middle" font-size="11" font-weight="bold" fill="#f97316">2</text>
    <text x="14" y="68.0" text-anchor="middle" font-size="11" font-weight="bold" fill="#f97316">3</text>
    <text x="14" y="90.0" text-anchor="middle" font-size="11" font-weight="bold" fill="#f97316">4</text>
    <text x="218.0" y="40.0" text-anchor="middle" font-size="11" font-weight="bold" fill="#f97316">30</text><line x1="210.0" y1="43.5" x2="226.0" y2="43.5" stroke="#f97316" stroke-width="1.1"/><text x="218.0" y="53.5" text-anchor="middle" font-size="11" font-weight="bold" fill="#f97316">7</text>
    <text x="218" y="76" text-anchor="middle" font-size="12" fill="#334155">est entre</text>
    <text x="218" y="95" text-anchor="middle" font-size="14" font-weight="bold" fill="#0f172a">4 et 5</text>
  </g>
  <g class="anim c1" data-caption="1">
    <text x="150" y="146" text-anchor="middle" font-size="11.5" fill="#334155">fais un <tspan font-weight="bold" fill="#b45309">paquet de 7</tspan> : tu as 7</text>
  </g>
  <g class="anim c2" data-caption="2">
    <text x="150" y="146" text-anchor="middle" font-size="11.5" fill="#334155">continue les paquets : <tspan font-weight="bold" fill="#b45309">14, 21, 28…</tspan></text>
  </g>
  <g class="anim c3" data-caption="3">
    <text x="150" y="146" text-anchor="middle" font-size="11.5" fill="#334155">2 de plus : <tspan font-weight="bold" fill="#f97316">30 atteint</tspan>, pas de 5ᵉ paquet plein</text>
  </g>
  <g class="anim c4" data-caption="4">
    <text x="150" y="146" text-anchor="middle" font-size="11.5" fill="#334155"><tspan font-weight="bold" fill="#f97316">4 paquets pleins</tspan> : entre <tspan font-weight="bold">4</tspan> et <tspan font-weight="bold">5</tspan></text>
  </g>
</svg>`.trim();

const FICHE_ENCADREMENT = {
    pages: [
        {
            titre: 'Fais des paquets de 7',
            lignes: [
                'Entre quels entiers se situe $\\dfrac{30}{7}$ ? Fais des **paquets de 7** jusqu\'à atteindre 30, puis compte les **paquets pleins**.',
                '$\\dfrac{30}{7}$ se situe entre **4 et 5** : deux entiers **consécutifs** (ils se suivent).',
            ],
            svg: SVG_PAQUETS,
        },
    ],
};

// Une même droite, plusieurs partages (carte PPCM), animé sobre :
// UNE droite, partages EMBOÎTÉS — en 12 (double-flèches sous la
// droite) puis en 3 (double-flèches au-dessus), 2/3 tombe pile sur
// un trait du 12. Couple (3,12) hors pool.
const SVG_PARTAGES = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 160" width="290" height="155" role="img" data-etapes="3"
     aria-label="Une demi-droite graduée de 0 à 1. Elle se partage d’abord en 12 parts égales, marquées par des petites flèches : 1 douzième se place au premier trait. La même droite se partage aussi en 3 grandes parts, marquées au-dessus : 2 tiers tombe pile sur une graduation du partage en 12. Une même droite porte plusieurs partages">
  <style>
    .anim { opacity: 1; }
    [data-caption] { opacity: 0; }
    [data-caption="3"] { opacity: 1; }
    @media (prefers-reduced-motion: no-preference) {
      .d1 { opacity: 0; animation: cp623par 6s linear infinite 0s; }
      .c1 { opacity: 0; animation: cp623parc 6s linear infinite 0s; }
      .d2 { opacity: 0; animation: cp623par 6s linear infinite 2s; }
      .c2 { opacity: 0; animation: cp623parc 6s linear infinite 2s; }
      .d3 { opacity: 0; animation: cp623par 6s linear infinite 4s; }
      .c3 { opacity: 0; animation: cp623parcf 6s linear infinite 4s; }
    }
    @keyframes cp623par { 0%, 3% { opacity: 0; } 8%, 94% { opacity: 1; } 98%, 100% { opacity: 0; } }
    @keyframes cp623parc { 0%, 3% { opacity: 0; } 7%, 30% { opacity: 1; } 35%, 100% { opacity: 0; } }
    @keyframes cp623parcf { 0%, 3% { opacity: 0; } 7%, 94% { opacity: 1; } 98%, 100% { opacity: 0; } }
  </style>
  <line x1="14" y1="70.0" x2="286" y2="70.0" stroke="#475569" stroke-width="1.5"/>
  <line x1="20.0" y1="61.0" x2="20.0" y2="79.0" stroke="#475569" stroke-width="1.5"/>
  <line x1="280.0" y1="61.0" x2="280.0" y2="79.0" stroke="#475569" stroke-width="1.5"/>
  <text x="20.0" y="101" text-anchor="middle" font-size="11" fill="#475569">0</text>
  <text x="280.0" y="101" text-anchor="middle" font-size="11" fill="#475569">1</text>
  <g class="anim d1" data-etape="1">
    <line x1="41.7" y1="65.0" x2="41.7" y2="75.0" stroke="#f97316" stroke-width="1.1"/>
    <line x1="63.3" y1="65.0" x2="63.3" y2="75.0" stroke="#f97316" stroke-width="1.1"/>
    <line x1="85.0" y1="65.0" x2="85.0" y2="75.0" stroke="#f97316" stroke-width="1.1"/>
    <line x1="106.7" y1="65.0" x2="106.7" y2="75.0" stroke="#f97316" stroke-width="1.1"/>
    <line x1="128.3" y1="65.0" x2="128.3" y2="75.0" stroke="#f97316" stroke-width="1.1"/>
    <line x1="150.0" y1="65.0" x2="150.0" y2="75.0" stroke="#f97316" stroke-width="1.1"/>
    <line x1="171.7" y1="65.0" x2="171.7" y2="75.0" stroke="#f97316" stroke-width="1.1"/>
    <line x1="193.3" y1="65.0" x2="193.3" y2="75.0" stroke="#f97316" stroke-width="1.1"/>
    <line x1="215.0" y1="65.0" x2="215.0" y2="75.0" stroke="#f97316" stroke-width="1.1"/>
    <line x1="236.7" y1="65.0" x2="236.7" y2="75.0" stroke="#f97316" stroke-width="1.1"/>
    <line x1="258.3" y1="65.0" x2="258.3" y2="75.0" stroke="#f97316" stroke-width="1.1"/>
    <line x1="24.0" y1="84.0" x2="37.7" y2="84.0" stroke="#f97316" stroke-width="1.1"/><polygon points="21.5,84.0 25.5,81.4 25.5,86.6" fill="#f97316"/><polygon points="40.2,84.0 36.2,81.4 36.2,86.6" fill="#f97316"/>
    <line x1="45.7" y1="84.0" x2="59.3" y2="84.0" stroke="#f97316" stroke-width="1.1"/><polygon points="43.2,84.0 47.2,81.4 47.2,86.6" fill="#f97316"/><polygon points="61.8,84.0 57.8,81.4 57.8,86.6" fill="#f97316"/>
    <line x1="67.3" y1="84.0" x2="81.0" y2="84.0" stroke="#f97316" stroke-width="1.1"/><polygon points="64.8,84.0 68.8,81.4 68.8,86.6" fill="#f97316"/><polygon points="83.5,84.0 79.5,81.4 79.5,86.6" fill="#f97316"/>
    <line x1="89.0" y1="84.0" x2="102.7" y2="84.0" stroke="#f97316" stroke-width="1.1"/><polygon points="86.5,84.0 90.5,81.4 90.5,86.6" fill="#f97316"/><polygon points="105.2,84.0 101.2,81.4 101.2,86.6" fill="#f97316"/>
    <line x1="110.7" y1="84.0" x2="124.3" y2="84.0" stroke="#f97316" stroke-width="1.1"/><polygon points="108.2,84.0 112.2,81.4 112.2,86.6" fill="#f97316"/><polygon points="126.8,84.0 122.8,81.4 122.8,86.6" fill="#f97316"/>
    <line x1="132.3" y1="84.0" x2="146.0" y2="84.0" stroke="#f97316" stroke-width="1.1"/><polygon points="129.8,84.0 133.8,81.4 133.8,86.6" fill="#f97316"/><polygon points="148.5,84.0 144.5,81.4 144.5,86.6" fill="#f97316"/>
    <line x1="154.0" y1="84.0" x2="167.7" y2="84.0" stroke="#f97316" stroke-width="1.1"/><polygon points="151.5,84.0 155.5,81.4 155.5,86.6" fill="#f97316"/><polygon points="170.2,84.0 166.2,81.4 166.2,86.6" fill="#f97316"/>
    <line x1="175.7" y1="84.0" x2="189.3" y2="84.0" stroke="#f97316" stroke-width="1.1"/><polygon points="173.2,84.0 177.2,81.4 177.2,86.6" fill="#f97316"/><polygon points="191.8,84.0 187.8,81.4 187.8,86.6" fill="#f97316"/>
    <line x1="197.3" y1="84.0" x2="211.0" y2="84.0" stroke="#f97316" stroke-width="1.1"/><polygon points="194.8,84.0 198.8,81.4 198.8,86.6" fill="#f97316"/><polygon points="213.5,84.0 209.5,81.4 209.5,86.6" fill="#f97316"/>
    <line x1="219.0" y1="84.0" x2="232.7" y2="84.0" stroke="#f97316" stroke-width="1.1"/><polygon points="216.5,84.0 220.5,81.4 220.5,86.6" fill="#f97316"/><polygon points="235.2,84.0 231.2,81.4 231.2,86.6" fill="#f97316"/>
    <line x1="240.7" y1="84.0" x2="254.3" y2="84.0" stroke="#f97316" stroke-width="1.1"/><polygon points="238.2,84.0 242.2,81.4 242.2,86.6" fill="#f97316"/><polygon points="256.8,84.0 252.8,81.4 252.8,86.6" fill="#f97316"/>
    <line x1="262.3" y1="84.0" x2="276.0" y2="84.0" stroke="#f97316" stroke-width="1.1"/><polygon points="259.8,84.0 263.8,81.4 263.8,86.6" fill="#f97316"/><polygon points="278.5,84.0 274.5,81.4 274.5,86.6" fill="#f97316"/>
    <circle cx="41.7" cy="70.0" r="4" fill="#f97316"/>
    <text x="41.7" y="30.0" text-anchor="middle" font-size="10" font-weight="bold" fill="#f97316">1</text><line x1="33.2" y1="33.5" x2="50.2" y2="33.5" stroke="#f97316" stroke-width="1.1"/><text x="41.7" y="43.0" text-anchor="middle" font-size="10" font-weight="bold" fill="#f97316">12</text>
  </g>
  <g class="anim d2" data-etape="2">
    <line x1="106.7" y1="61.0" x2="106.7" y2="79.0" stroke="#b45309" stroke-width="2.2"/>
    <line x1="193.3" y1="61.0" x2="193.3" y2="79.0" stroke="#b45309" stroke-width="2.2"/>
    <line x1="24.0" y1="56.0" x2="102.7" y2="56.0" stroke="#b45309" stroke-width="1.4"/><polygon points="21.5,56.0 25.5,52.8 25.5,59.2" fill="#b45309"/><polygon points="105.2,56.0 101.2,52.8 101.2,59.2" fill="#b45309"/>
    <line x1="110.7" y1="56.0" x2="189.3" y2="56.0" stroke="#b45309" stroke-width="1.4"/><polygon points="108.2,56.0 112.2,52.8 112.2,59.2" fill="#b45309"/><polygon points="191.8,56.0 187.8,52.8 187.8,59.2" fill="#b45309"/>
    <line x1="197.3" y1="56.0" x2="276.0" y2="56.0" stroke="#b45309" stroke-width="1.4"/><polygon points="194.8,56.0 198.8,52.8 198.8,59.2" fill="#b45309"/><polygon points="278.5,56.0 274.5,52.8 274.5,59.2" fill="#b45309"/>
    <circle cx="193.3" cy="70.0" r="4" fill="#b45309"/>
    <text x="193.3" y="30.0" text-anchor="middle" font-size="10" font-weight="bold" fill="#b45309">2</text><line x1="186.3" y1="33.5" x2="200.3" y2="33.5" stroke="#b45309" stroke-width="1.1"/><text x="193.3" y="43.0" text-anchor="middle" font-size="10" font-weight="bold" fill="#b45309">3</text>
  </g>
  <g class="anim d3" data-etape="3">
    <circle cx="41.7" cy="70.0" r="7" fill="none" stroke="#f97316" stroke-width="1.6"/>
    <circle cx="193.3" cy="70.0" r="7" fill="none" stroke="#b45309" stroke-width="1.6"/>
  </g>
  <g class="anim c1" data-caption="1">
    <text x="205" y="146" text-anchor="end" font-size="11.5" fill="#334155">la droite se partage <tspan font-weight="bold" fill="#f97316">en 12</tspan> : voici</text>
    <text x="220.0" y="134.0" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#f97316">1</text><line x1="211.5" y1="137.5" x2="228.5" y2="137.5" stroke="#f97316" stroke-width="1.1"/><text x="220.0" y="147.0" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#f97316">12</text>
  </g>
  <g class="anim c2" data-caption="2">
    <text x="215" y="146" text-anchor="end" font-size="11.5" fill="#334155">la <tspan font-weight="bold">même droite</tspan>, partagée <tspan font-weight="bold" fill="#b45309">en 3</tspan> : voici</text>
    <text x="229.0" y="134.0" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#b45309">2</text><line x1="222.0" y1="137.5" x2="236.0" y2="137.5" stroke="#b45309" stroke-width="1.1"/><text x="229.0" y="147.0" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#b45309">3</text>
  </g>
  <g class="anim c3" data-caption="3">
    <text x="150" y="146" text-anchor="middle" font-size="11.5" fill="#334155">une <tspan font-weight="bold">même droite</tspan>, deux <tspan font-weight="bold">partages</tspan> !</text>
  </g>
</svg>`.trim();

const FICHE_PARTAGES = {
    pages: [
        {
            titre: 'Une demi-droite, plusieurs partages',
            lignes: [
                'Une même unité peut se partager **en 12**, **en 3**… sur la même demi-droite.',
                'Compte les **graduations d\'une unité** : c\'est ça, le partage de la demi-droite.',
            ],
            svg: SVG_PARTAGES,
        },
    ],
};

// Décomposer en somme (placer_decomposition_saisie) : jumelle des
// paquets, mais le temps 4 conclut sur LA SOMME 30/7 = 4 + 2/7
// (retour user : cet exo demande la somme, pas l’encadrement).
const SVG_PAQUETS_SOMME = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 160" width="290" height="155" role="img" data-etapes="4"
     aria-label="On fait des paquets de 7 jusqu’à atteindre 30 : un paquet fait 7, puis 14, 21, 28. Avec 2 de plus on atteint 30. On écrit la somme : 30 septièmes égale 4 paquets entiers plus 2 septièmes">
  <style>
    .anim { opacity: 1; }
    [data-caption] { opacity: 0; }
    [data-caption="4"] { opacity: 1; }
    @media (prefers-reduced-motion: no-preference) {
      .d1 { opacity: 0; animation: cp623som 8s linear infinite 0s; }
      .c1 { opacity: 0; animation: cp623somc 8s linear infinite 0s; }
      .d2 { opacity: 0; animation: cp623som 8s linear infinite 2s; }
      .c2 { opacity: 0; animation: cp623somc 8s linear infinite 2s; }
      .d3 { opacity: 0; animation: cp623som 8s linear infinite 4s; }
      .c3 { opacity: 0; animation: cp623somc 8s linear infinite 4s; }
      .d4 { opacity: 0; animation: cp623som 8s linear infinite 6s; }
      .c4 { opacity: 0; animation: cp623somcf 8s linear infinite 6s; }
    }
    @keyframes cp623som { 0%, 2% { opacity: 0; } 6%, 95% { opacity: 1; } 98%, 100% { opacity: 0; } }
    @keyframes cp623somc { 0%, 2% { opacity: 0; } 5%, 22% { opacity: 1; } 26%, 100% { opacity: 0; } }
    @keyframes cp623somcf { 0%, 2% { opacity: 0; } 5%, 95% { opacity: 1; } 98%, 100% { opacity: 0; } }
  </style>
  <g class="anim d1" data-etape="1">
    <circle cx="34.0" cy="20.0" r="4.0" fill="#334155"/>
    <circle cx="49.0" cy="20.0" r="4.0" fill="#334155"/>
    <circle cx="64.0" cy="20.0" r="4.0" fill="#334155"/>
    <circle cx="79.0" cy="20.0" r="4.0" fill="#334155"/>
    <circle cx="94.0" cy="20.0" r="4.0" fill="#334155"/>
    <circle cx="109.0" cy="20.0" r="4.0" fill="#334155"/>
    <circle cx="124.0" cy="20.0" r="4.0" fill="#334155"/>
    <rect x="25.0" y="11.0" width="108.0" height="18" rx="9" fill="none" stroke="#b45309" stroke-width="1.8"/>
    <text x="140.0" y="24.0" font-size="11" font-weight="bold" fill="#b45309">7</text>
  </g>
  <g class="anim d2" data-etape="2">
    <circle cx="34.0" cy="42.0" r="4.0" fill="#334155"/>
    <circle cx="49.0" cy="42.0" r="4.0" fill="#334155"/>
    <circle cx="64.0" cy="42.0" r="4.0" fill="#334155"/>
    <circle cx="79.0" cy="42.0" r="4.0" fill="#334155"/>
    <circle cx="94.0" cy="42.0" r="4.0" fill="#334155"/>
    <circle cx="109.0" cy="42.0" r="4.0" fill="#334155"/>
    <circle cx="124.0" cy="42.0" r="4.0" fill="#334155"/>
    <rect x="25.0" y="33.0" width="108.0" height="18" rx="9" fill="none" stroke="#b45309" stroke-width="1.8"/>
    <text x="140.0" y="46.0" font-size="11" font-weight="bold" fill="#b45309">14</text>
    <circle cx="34.0" cy="64.0" r="4.0" fill="#334155"/>
    <circle cx="49.0" cy="64.0" r="4.0" fill="#334155"/>
    <circle cx="64.0" cy="64.0" r="4.0" fill="#334155"/>
    <circle cx="79.0" cy="64.0" r="4.0" fill="#334155"/>
    <circle cx="94.0" cy="64.0" r="4.0" fill="#334155"/>
    <circle cx="109.0" cy="64.0" r="4.0" fill="#334155"/>
    <circle cx="124.0" cy="64.0" r="4.0" fill="#334155"/>
    <rect x="25.0" y="55.0" width="108.0" height="18" rx="9" fill="none" stroke="#b45309" stroke-width="1.8"/>
    <text x="140.0" y="68.0" font-size="11" font-weight="bold" fill="#b45309">21</text>
    <circle cx="34.0" cy="86.0" r="4.0" fill="#334155"/>
    <circle cx="49.0" cy="86.0" r="4.0" fill="#334155"/>
    <circle cx="64.0" cy="86.0" r="4.0" fill="#334155"/>
    <circle cx="79.0" cy="86.0" r="4.0" fill="#334155"/>
    <circle cx="94.0" cy="86.0" r="4.0" fill="#334155"/>
    <circle cx="109.0" cy="86.0" r="4.0" fill="#334155"/>
    <circle cx="124.0" cy="86.0" r="4.0" fill="#334155"/>
    <rect x="25.0" y="77.0" width="108.0" height="18" rx="9" fill="none" stroke="#b45309" stroke-width="1.8"/>
    <text x="140.0" y="90.0" font-size="11" font-weight="bold" fill="#b45309">28</text>
  </g>
  <g class="anim d3" data-etape="3">
    <circle cx="34.0" cy="108.0" r="5.0" fill="#f97316"/>
    <circle cx="49.0" cy="108.0" r="5.0" fill="#f97316"/>
    <text x="70.0" y="112.0" font-size="11" font-weight="bold" fill="#f97316">30 !</text>
  </g>
  <g class="anim d4" data-etape="4">
    <text x="14" y="24.0" text-anchor="middle" font-size="11" font-weight="bold" fill="#b45309">1</text>
    <text x="14" y="46.0" text-anchor="middle" font-size="11" font-weight="bold" fill="#b45309">2</text>
    <text x="14" y="68.0" text-anchor="middle" font-size="11" font-weight="bold" fill="#b45309">3</text>
    <text x="14" y="90.0" text-anchor="middle" font-size="11" font-weight="bold" fill="#b45309">4</text>
    <text x="196.0" y="63.0" text-anchor="middle" font-size="11" font-weight="bold" fill="#334155">30</text><line x1="187.5" y1="66.5" x2="204.5" y2="66.5" stroke="#334155" stroke-width="1.1"/><text x="196.0" y="76.5" text-anchor="middle" font-size="11" font-weight="bold" fill="#334155">7</text>
    <text x="214" y="71" text-anchor="middle" font-size="13" fill="#334155">=</text>
    <text x="229" y="72" text-anchor="middle" font-size="16" font-weight="bold" fill="#b45309">4</text>
    <text x="243" y="71" text-anchor="middle" font-size="13" fill="#334155">+</text>
    <text x="259.0" y="63.0" text-anchor="middle" font-size="11" font-weight="bold" fill="#f97316">2</text><line x1="252.0" y1="66.5" x2="266.0" y2="66.5" stroke="#f97316" stroke-width="1.1"/><text x="259.0" y="76.5" text-anchor="middle" font-size="11" font-weight="bold" fill="#f97316">7</text>
  </g>
  <g class="anim c1" data-caption="1">
    <text x="150" y="146" text-anchor="middle" font-size="11.5" fill="#334155">fais un <tspan font-weight="bold" fill="#b45309">paquet de 7</tspan> : tu as 7</text>
  </g>
  <g class="anim c2" data-caption="2">
    <text x="150" y="146" text-anchor="middle" font-size="11.5" fill="#334155">continue les paquets : <tspan font-weight="bold" fill="#b45309">14, 21, 28…</tspan></text>
  </g>
  <g class="anim c3" data-caption="3">
    <text x="150" y="146" text-anchor="middle" font-size="11.5" fill="#334155">2 de plus : <tspan font-weight="bold" fill="#f97316">30 atteint</tspan></text>
  </g>
  <g class="anim c4" data-caption="4">
    <text x="150" y="146" text-anchor="middle" font-size="11.5" fill="#334155"><tspan font-weight="bold" fill="#b45309">4 paquets entiers</tspan> + <tspan font-weight="bold" fill="#f97316">2 septièmes</tspan> !</text>
  </g>
</svg>`.trim();

const FICHE_DECOMPOSITION = {
    pages: [
        {
            titre: 'Des paquets entiers + un reste',
            lignes: [
                'On veut **décomposer** $\\dfrac{30}{7}$ en une **addition** d\'un nombre entier et d\'une fraction.',
                'Fais des **paquets de 7** jusqu\'à atteindre 30 : **4 paquets entiers**, et il reste **2**.',
            ],
            svg: SVG_PAQUETS_SOMME,
        },
    ],
};

// V/F multi-droites : le geste propre à cet exercice est de CHOISIR la
// droite adaptée avant de répondre — l'indice, c'est le dénominateur
// (retour user). Sobre ; septièmes hors pool (V/F tire b dans 3..6).
const FICHE_CHOIX_DROITE = {
    pages: [
        {
            titre: 'Choisis la bonne demi-droite',
            lignes: [
                'Plusieurs demi-droites graduées sont proposées : avant de répondre, **choisis la plus adaptée**.',
                'L\'indice, c\'est le **dénominateur** : $\\dfrac{9}{7}$ se lit sur la demi-droite **partagée en 7**. Compte les graduations d\'une unité pour la reconnaître.',
                'Puis place la fraction sur cette demi-droite, et réponds.',
            ],
        },
    ],
};

const CP_623 = {
    placer_fraction_qcm: FICHE_PLACER,
    placer_fraction_interactif: FICHE_PLACER,
    placer_fraction_relier: FICHE_PLACER,
    placer_encadrement_saisie: FICHE_ENCADREMENT,
    placer_decomposition_saisie: FICHE_DECOMPOSITION,
    placer_fraction_vf: FICHE_CHOIX_DROITE,
    placer_den_melanges_qcm: FICHE_PARTAGES,
};

export default CP_623;
